module.exports = __webpack_public_path__ + "img/google.8bc1326.svg";